import { hotTopics } from "@/mocks/gossip";

export default function HotBoard() {
  const rankColor = (i: number) => {
    if (i === 0) return "text-primary-600";
    if (i === 1) return "text-accent-600";
    if (i === 2) return "text-secondary-600";
    return "text-foreground-300";
  };

  return (
    <section id="hot" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-accent-600">
              <i className="ri-fire-fill"></i> 今日热议榜
            </p>
            <h2 className="serif-title mt-2 text-3xl font-black text-foreground-950 md:text-4xl">
              全民在刷的 Top 6
            </h2>
          </div>
          <span className="flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-xs font-medium text-foreground-500 border border-background-200">
            <i className="ri-time-line"></i> 数据实时更新 · 截至 22:00
          </span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {hotTopics.map((item, i) => (
            <article
              key={item.id}
              className="flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-background-300 md:p-5"
            >
              <span className={`serif-title text-3xl font-black leading-none ${rankColor(i)}`}>
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="rounded-md bg-background-200/80 px-2 py-0.5 text-xs font-semibold text-foreground-600">
                    {item.tag}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-primary-500">
                    <i className="ri-fire-line"></i>
                    <span className="font-semibold">{item.heat} 万</span>
                  </span>
                </div>
                <h3 className="serif-title mt-2 text-base font-bold leading-snug text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}